export default __webpack_public_path__ + "static/media/Ct14.d1131cf2.png";